import { SealPercent } from "@phosphor-icons/react";
import { Icon } from "@shopflo/ui/icon";
import { useCheckoutContext } from "lib/contexts/CheckoutProvider";
import { useLocale } from "lib/hooks/useLocale";
import { CouponType } from "lib/types/checkout";
import { currencyFormatter } from "lib/utils/formatters";
import React from "react";
import DotsLoader from "components/common/loaders/DotsLoader";
import ViewOtherCouponsTile from "./ViewCouponsTile";
import { getCardBorderStyles } from "lib/utils/UIUtils";
import { getTextColorByBrightness, hexToRgba } from "@shopflo/ui/utils";
import { MaxDiscountCouponTileProps } from "../couponProps";
import MultiGiftCard from "../cards/MultiGiftCard";
import GiftCard from "../cards/GiftCard";
import Gyftr from "../cards/Gyftr";
const MaxDiscountCouponTile: React.FC<MaxDiscountCouponTileProps> = ({
  showCoupons,
  availableCoupons,
  maxAvailableCoupon,
  handleDiscountApply,
  renderCouponSummaryStrip,
  setCouponApplyError,
  customisations,
  onOpenPartnerOffers,
  onOpen,
  isLoading = false,
  partnerOffersConfig,
}) => {
  const { t } = useLocale();
  const {
    actions: { setCheckoutModal },
  } = useCheckoutContext();

  const couponPromotionDisplayTxt =
    maxAvailableCoupon?.coupon_details?.coupon_type === CouponType.PAYMENT_OFFER
      ? t("save")
      : `${t("save")} ${currencyFormatter(maxAvailableCoupon?.total_discount)}`;


  return (
    <div className="isolate flex w-full flex-col !overflow-hidden rounded-xl  text-yay-dark"
      style={{
        borderRadius: customisations?.cardRadius,
        ...getCardBorderStyles({
          borderSides: customisations?.cardBorderSides,
          borderWidth: customisations?.cardBorderWidth,
          borderColor: customisations?.callout?.borderColor,
        })
      }}
    >
      <div className="flex flex-col cursor-pointer">
        {showCoupons && (
          <div className="flex flex-col">
            <div
              className="flex justify-between items-center p-3 bg-white"
              style={{
                backgroundColor: customisations?.callout?.backgroundColor,
              }}
              onClick={() => {
                setCheckoutModal("DISCOUNT_LIST");
                setCouponApplyError({ status: false, message: "" });
              }}>
              <div className="flex gap-1 ">
                <Icon IconComponent={SealPercent} size="sm" iconProps={{ weight: "fill", color: customisations?.callout?.primaryColor }}></Icon>
                <div className="flex flex-col h-full space-y-[3px] justify-start items-start w-full">
                  <p className="text-text-sm-medium text-yay-dark"
                    style={{
                      color: customisations?.callout?.primaryColor,
                    }}
                  >
                    {maxAvailableCoupon?.coupon_details?.coupon_type === CouponType.REWARD_AS_DISCOUNT &&
                      maxAvailableCoupon?.coupon_details?.coupon_reward_config?.wallet_type === "TICKERTAPE"
                      ? maxAvailableCoupon?.coupon_details?.header
                      : couponPromotionDisplayTxt}
                  </p>
                  <p className="text-text-xs-semibold">
                    <span className="text-coal-light"
                      style={{
                        color: customisations?.callout?.infoColor,
                        opacity: 0.8,
                      }}
                    >{t("with")}</span>
                    <span className="text-coal-dark"
                      style={{
                        color: customisations?.callout?.infoColor,
                      }}
                    >
                      {" '" +
                        (maxAvailableCoupon?.coupon_details?.title ||
                          maxAvailableCoupon?.coupon_details?.coupon_code) +
                        "'"}
                    </span>
                  </p>
                </div>
              </div>
              <div
                onClick={(e) => {
                  if (isLoading) return;
                  e.stopPropagation();
                  handleDiscountApply(maxAvailableCoupon?.coupon_details?.coupon_code);
                }}
                style={{
                  backgroundColor: hexToRgba(customisations?.callout?.primaryColor ?? '2C874A', 0.1),
                  borderColor: hexToRgba(customisations?.callout?.primaryColor ?? '2C874A', 0.25),
                }}
                className="flex z-20 justify-center px-3 py-1.5 items-center h-full border border-green-dark/25 bg-green-dark/10 rounded-md cursor-pointer min-w-[52px] min-h-[32px]">
                {isLoading ? (
                  <DotsLoader color={customisations?.callout?.primaryColor ?? "#2C874A"} />
                ) : (
                  <span className="text-text-xs-semibold text-center flex"
                    style={{
                      color: customisations?.callout?.primaryColor,
                    }}
                  >{t("apply")}</span>
                )}
              </div>
            </div>

            <div
              onClick={(e) => {
                e.stopPropagation();
              }}>
              {renderCouponSummaryStrip()}
            </div>
          </div>
        )}
        <div className=" flex flex-col justify-between border-t py-0.5"
          style={{
            backgroundColor: customisations?.footer?.backgroundColor,
            borderColor: getTextColorByBrightness({ bgHexColor: customisations?.footer?.backgroundColor ?? '2C874A', lightOpacity: 24 }),
          }}
        >
          <ViewOtherCouponsTile
            availableCoupons={availableCoupons}
            setCouponApplyError={setCouponApplyError}
            customisations={customisations}
            onOpenPartnerOffers={onOpenPartnerOffers}
            onOpen={onOpen}
            partnerOffersConfig={partnerOffersConfig}
          />
            <GiftCard dividerColor={getTextColorByBrightness({ bgHexColor: customisations?.footer?.backgroundColor ?? '2C874A', lightOpacity: 24 })} />
            <Gyftr dividerColor={getTextColorByBrightness({ bgHexColor: customisations?.footer?.backgroundColor ?? '2C874A', lightOpacity: 24 })} />
          <MultiGiftCard dividerColor={getTextColorByBrightness({ bgHexColor: customisations?.footer?.backgroundColor ?? '2C874A', lightOpacity: 24 })} />
        </div>
      </div>
    </div>
  );
};

export default MaxDiscountCouponTile;
